import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import OpenSeaButton from '../OpenSeaButton';
import PolygonButton from '../PolygonButton';
import HtmlTooltip from './HtmlTooltip';
import InformationIcon from './InformationIcon';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

export default function BlockchainLinks({ openSea, polygonScan }) {
    const { t } = useTranslation();
    return (
        <Box
            sx={{
                borderRadius: 4,
                px: 2,
                py: 2,
                background: !openSea && !polygonScan ? '#F6F6F6' : '#FFFFFF',
            }}
        >
            <Stack spacing={1}>
                <Typography variant="subtitle1">{t('certificate.see_in_blockchain')}</Typography>

                {!openSea && !polygonScan && (
                    <>
                        <Stack direction={'row'} alignItems={'center'}>
                            <Typography variant="body2" pr={1}>
                                {t('certificate.not_in_blockchain')}
                            </Typography>
                        </Stack>
                    </>
                )}
                <Grid container>
                    {openSea && (
                        <Grid item xs={12} md={6}>
                            <Stack direction={'row'} alignItems={'center'} pt={1} pb={1}>
                                <Typography variant="body2" pr={1}>
                                    {t('certificate.see_encripted_certificate')}
                                </Typography>
                                <HtmlTooltip text={t('certificate.opensea_explanation')}>
                                    <InformationIcon white={false} />
                                </HtmlTooltip>
                            </Stack>
                            <OpenSeaButton link={openSea} />
                        </Grid>
                    )}

                    {polygonScan && (
                        <Grid item xs={12} md={6}>
                            <Stack direction={'row'} pt={1} pb={1} alignItems={'center'}>
                                <Typography variant="body2" pr={1}>
                                    {t('certificate.see_transaction')}
                                </Typography>
                                <HtmlTooltip text={t('certificate.to_access_to_detail_blockchain')}>
                                    <InformationIcon white={false} />
                                </HtmlTooltip>
                            </Stack>
                            <PolygonButton link={polygonScan} />
                        </Grid>
                    )}
                </Grid>
            </Stack>
        </Box>
    );
}
